import React from "react";
import WhatAppOffers from "./body/WhatAppOffers";
import Examples from "./examples/Examples";
import LoginAndRegister from "./loginAndRegister/LoginAndRegister";
import IUser from "../../types/user.type";
import Cards from "../cards/Cards";

type Props = {
  updateUserState: (user: IUser) => void;
};

const Home: React.FC<Props> = ({ updateUserState }) => {
  return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "2rem",            // odstęp między sekcjami
          padding: "2rem",
          flexWrap: "wrap"        // żeby na mniejszych ekranach się zawijało
        }}
      >
        <div style={{ flex: "1 1 45%", minWidth: "300px" }}>
          <WhatAppOffers />
        </div>

        <div style={{ flex: "1 1 45%", minWidth: "300px" }}>
          <LoginAndRegister updateUserState={updateUserState} />
        </div>

        <div style={{ flex: "1 1 45%", minWidth: "300px" }}>
          <Cards />
          {/* <Examples /> */}
        </div>
      </div>
  );
};

export default Home;
